import PropTypes from 'prop-types';
import React from 'react';

import {
  StyledButton,
  StyledTd,
  StyledTeamEmptyStateText,
  StyledTeamEmptyStateWrapper,
  StyledTr,
} from './styles';

const TeamEmptyState = ({ onClick }) => {
  return (
    <StyledTr>
      <StyledTd colSpan="5">
        <StyledTeamEmptyStateWrapper>
          <StyledTeamEmptyStateText>
            Looks like you don’t have any team members. Want to get started and
            add one?
          </StyledTeamEmptyStateText>
          <StyledButton
            data-test-id="466964d3-ea3b-4395-aae0-2707bf1fe9d5"
            onClick={onClick}
            variant="stroke"
          >
            + <span>Add Member</span>
          </StyledButton>
        </StyledTeamEmptyStateWrapper>
      </StyledTd>
    </StyledTr>
  );
};

TeamEmptyState.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default TeamEmptyState;
